import React from 'react'

const PopUp7 = ({setPopUp}) => {
    return (
        <div className='flex z-30 justify-center px-2  w-full py-3 absolute top-1/4'>


            <div className='w-[20rem] shadow-lg py-4 px-4 bg-white rounded-lg'>
                <div className='grid grid-cols-3 gap-2  items-center py-2'>
                    <div className=' h-1 bg-[#0062FF]  rounded-full'>

                    </div>
                    <div className=' h-1 bg-[#0062FF] rounded-full'></div>
                    <div className=' h-1 bg-[#0062FF] rounded-full'></div>
                </div>


                <div className='flex flex-col  items-center  justify-center'>
                    <h1 className='text-2xl pb-2 text-center pt-2 font-semibold'>Important Message</h1>

                    <p className='text-[20px] text-center pt-4 pb-4 max-w-[90%] '> Your <span className='text-[#0062FF]'>14 day free trial</span>  will start when all documents are signed. We’ll send you <br /> a confirmation email.</p>
                    <p className='text-[20px] text-center  pb-1 max-w-[90%] '> 
                    In the meantime,<span className='font-semibold'>you can <br /> still use Deli,</span> but without specific addresses or locations.</p>
                    <button onClick={() => {
                        
                        setPopUp(pre => pre + 1)
                    }} className='bg-[#0062FF] text-white py-2 mt-3 w-full rounded-md transition-transform duration-300 hover:scale-105 hover:bg-blue-600'>Next</button>
                </div>
            </div>
        </div>
    )
}

export default PopUp7